import { Component, OnInit } from '@angular/core';
import { DataStorageService } from '../services/data-storage.service';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { environment } from '../../environments/environment';
import { BackendService } from '../services/backend.service';
import { WishListItem, Dealer, CustomerInfo } from '../models';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { RecaptchaTokenService } from '../services/recaptcha-token.service';
import { MatDialog } from '@angular/material';
import { SentWishlistDialogComponent } from '../dialogs/sent-wishlist-dialog/sent-wishlist-dialog';
import { GenericErrorDialogComponent } from '../dialogs/generic-error-dialog/generic-error-dialog';
import { LocalizationService } from '../services/localization.service';

// https://www.google.com/recaptcha/admin#site/340040195?setup

@Component({
    selector: 'app-send-wish-list-to-dealer',
    templateUrl: './send-wish-list-to-dealer.component.html',
    styleUrls: ['./send-wish-list-to-dealer.component.css']
})
export class SendWishListToDealerComponent implements OnInit {

    public mainForm: FormGroup;
    public isLoading = false;
    public isProduction = environment.production;
    public dealer: Dealer;
    public wishList: WishListItem[];
    private currentCounter: number;

    public isCassettiera: boolean = false;

    onScriptLoad() {
        console.log('Google reCAPTCHA loaded and is ready for use!');
    }

    onScriptError() {
        console.log('Something went long when loading the Google reCAPTCHA');
    }

    constructor(
        private dataStorageService: DataStorageService,
        private backendService: BackendService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private dialog: MatDialog,
        private recaptchaTokenService: RecaptchaTokenService,
        public loc: LocalizationService,)
    {
    }

    ngOnInit() {

        this.createForm();

        this.dealer = this.dataStorageService.getDealer();

        if (this.dealer == null) {
            console.warn('Dealer not set');
            this.router.navigate([ this.loc.currLang(), 'where-to-buy']);
            return;
        }

        // Carico le info del cliente se sono già presenti
        const customer = this.dataStorageService.getCustomerInfo();

        if (customer != null) {
            this.mainForm.setValue({
                firstName: customer.name,
                lastName: customer.surname,
                email: customer.mail,
                phone: customer.phone,
                canContact: customer.privacy,
                recaptcha: false
            });

            this.currentCounter = customer.counter;
        } else {
            console.log('No customer info in data storage');
        }

        this.wishList = this.dataStorageService.getConfiguration().wishList;

        this.isCassettiera = this.dataStorageService.getConfiguration().isCassettiera;
        if (typeof this.isCassettiera === 'undefined') {
            this.isCassettiera = false;
        }
    }

    createForm() {

        this.mainForm = this.fb.group({
            firstName: ['', [
                Validators.required,
            ]],
            lastName: ['', [
                Validators.required,
            ]],
            email: ['', [
                Validators.required,
                EmailValidator
            ]],
            phone: ['', [
                Validators.required,
            ]],
            canContact: ['', [
                Validators.requiredTrue
            ]],
            recaptcha: [false, [
                Validators.requiredTrue
            ]]
        });

    }

    onSubmit() {

        const challenge = this.recaptchaTokenService.getRecaptchaToken();

        this.isLoading = true;

        const customer = new CustomerInfo();
        customer.mail = this.mainForm.get('email').value;
        customer.phone = this.mainForm.get('phone').value;
        customer.counter = this.currentCounter == null ? 1 : this.currentCounter + 1;
        customer.name = this.mainForm.get('firstName').value;
        customer.surname = this.mainForm.get('lastName').value;
        customer.privacy = this.mainForm.get('canContact').value;

        this.dataStorageService.setCustomerInfo(customer);

        this.backendService.SendWishListToDealer(customer, this.dealer, this.wishList, challenge).subscribe(res => {
            if (res.result) {
                this.dialog.open(SentWishlistDialogComponent, {
                    width: '450px'
                });
            } else {
                this.dialog.open(GenericErrorDialogComponent, {
                    width: '450px'
                });
            }
            this.isLoading = false;
        }, err => {

            this.dialog.open(GenericErrorDialogComponent, {
                width: '300px'
            });

            this.isLoading = false;

        });


    }

    testData() {
        this.mainForm.setValue({
            firstName: 'Pippo',
            lastName: 'Plutone',
            email: 'test@test.it',
            phone: '37676754434',
            canContact: true
        });

    }

    isLang(lg: string): boolean
    {
      return this.loc.currLang() == lg;
    }

}

export function EmailValidator(control: AbstractControl) {

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(control.value)) {
        return null;
    }
    return { email: true };
}



// WEBPACK FOOTER //
// ./src/app/send-wish-list-to-dealer/send-wish-list-to-dealer.component.ts